/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_UnassignedInputs */

const en_tasks_unassigned = /** @type {(inputs: Tasks_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unassigned`)
};

const fr_tasks_unassigned = /** @type {(inputs: Tasks_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`non assignée`)
};

const ms_sg2_tasks_unassigned = /** @type {(inputs: Tasks_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tidak ditugaskan`)
};

/**
* | output |
* | --- |
* | "unassigned" |
*
* @param {Tasks_UnassignedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_unassigned = /** @type {((inputs?: Tasks_UnassignedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_UnassignedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_unassigned(inputs)
	if (locale === "fr") return fr_tasks_unassigned(inputs)
	return ms_sg2_tasks_unassigned(inputs)
});